import React, { useEffect, useState } from 'react'
import A4Page from '../A4Page'
import TopDetail from '../TopDetail'
import Page1 from './Page1'
import useOrderStore from 'store/client/orderStore'

const loadSVG = async (code) => {
  try {
    console.log(`[loadSVG] Gelen kod: ${code}`);
    const module = await import(`../../../../../assets/empty/${code}.svg`);
    console.log(`[loadSVG] İçe aktarılan module:`, module);
    return module.ReactComponent || module.default || null;
  } catch (error) {
    console.error(`[loadSVG] SVG yüklenemedi. Kod: ${code}, Hata:`, error);
    return null;
  }
};

const CardComponent = ({ referenceCode, data, selectedFscType }) => {
  const [SvgComponent, setSvgComponent] = useState(null);

  useEffect(() => {
    if (referenceCode) {
      loadSVG(referenceCode)
        .then((component) => {
          setSvgComponent(() => component);
        })
        .catch((error) => {
          console.error("[CardComponent] SVG yüklenirken hata:", error);
        });
    }
  }, [referenceCode]);

  if (!SvgComponent) {
    return <span>Loading...</span>;
  }

  return (
    <div style={{ position: "relative" }}>
      {typeof SvgComponent === "function" ? (
        <SvgComponent />
      ) : (
        <img src={SvgComponent} alt="SVG Image" style={{ width: "auto", height: "auto" }} />
      )}
    </div>
  );
};

const EmptyMain = ({ data, selectColor, tab }, ref) => {
  const [CardBackBack, setCardBackBack] = useState(null);
  const { referance } = useOrderStore();

  useEffect(() => {
    if (referance?.code) {
      loadSVG(referance.code)
        .then((component) => {
          setCardBackBack(() => component);
        })
        .catch((error) => {
          console.error("[useEffect - referance] SVG yüklenirken hata:", error);
        });
    }
  }, [referance]);

  const filteredAndGroupedSizes = data.brandLabel[selectColor].sizes
    .filter((item) => item.amount > 0)
    .reduce((acc, item, index) => {
      const groupIndex = Math.floor(index / referance?.linecount);
      if (!acc[groupIndex]) {
        acc[groupIndex] = { items: [], startIndex: index - (index % referance?.linecount) };
      }
      acc[groupIndex].items.push(item);
      return acc;
    }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} ref={ref}>
      {referance?.line1 ? (
        filteredAndGroupedSizes.map((groupObj, groupIndex) => (
          <A4Page key={groupIndex} type={referance?.line3}>
            <div className="space-y-5" style={{ position: 'relative' }}>
              <TopDetail values={data} selectColor={selectColor} tab={tab} />
              {groupObj.items.map((sizeData, index) => (
                <div key={index} style={{ position: "absolute", top: "10px", left: "10px" }}>
                  <Page1
                    key={groupObj.startIndex + index}
                    selectColor={selectColor}
                    barcodeValue={`0${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.priceLabel[selectColor]?.colorCode}${sizeData.sCode ? sizeData.sCode : ''}`}
                    data={data}
                    sizeData={sizeData}
                    inx={groupObj.startIndex + index}
                    CardBackBack={CardBackBack}
                  />
                </div>
              ))}
            </div>
          </A4Page>
        ))
      ) : (
        <A4Page key={1} type="dikey">
          <div className="space-y-5" style={{ position: 'relative' }}>
            <TopDetail values={data} selectColor={selectColor} tab={tab} />
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", paddingTop: 40 }}>
              <CardComponent referenceCode={referance?.code} data={data} selectedFscType={data.company?.fsctype} />
            </div>
          </div>
        </A4Page>
      )}
    </div>
  );
};

export default React.forwardRef(EmptyMain);
